import React, { useState } from 'react';
import './keywords.scss';

import { map } from 'underscore';
import { Text, Button } from '@ui-kit';
const Arrow = '/images/icons/chevron-gray500.svg';

const Keywords = ({ 
  keywords = [],
  onSelectKeyword = () => {},
  length = 0
}) => {
  let [viewAll, setViewAll] = useState(false);

  if (!keywords.length) {
    return;
  }

  const collapseTags = (event) => {
    setTimeout(()=> setViewAll((value)=> !value), 0);
  };

  const renderTags = () => {
    const copy_keywords = [...keywords];

    if (!viewAll) {
      const cuttedKeywordw = copy_keywords.slice(0, length);

      return map(cuttedKeywordw, (keyword, index) =>
        checkLength(keyword, index)
      );
    }

    return map(copy_keywords, (keyword, index) => checkLength(keyword, index));
  };

  const checkLength = (keyword, index) => {
    if (!keyword.length) {
      return;
    }

    return (
      <Button
        key={`keyword-${index}`}
        className="keywords__item mr-8 mb-8"
        theme="secondary-gray"
        size="sm"
        onClick={(e) => onSelectKeyword(keyword)}
      >
        {keyword}
      </Button>
    );
  };

  const renderButton = () => {
    if (checkAmount()) {
      return;
    }

    const classes = ['tag__parent', 'mr-8', 'mb-8'];
    const icon = Arrow;
    let label = 'View all';

    if (viewAll) {
      classes.push('right');
      label = 'Show less';
    }

    return (
      <Button
        key="view-all"
        className={classes.join(' ')}
        theme="secondary-gray keywords__item"
        size="sm"
        iconRight={icon}
        iconLeft={icon}
        onClick={collapseTags}
      >
        {label}
      </Button>
    );
  };

  const checkAmount = () => {
    return keywords.length <= length;
  };

 

  return (
    <div className="keywords__container">
      <Text as="h4" className="keywords__title mb-12">
        Related Tags
      </Text>
      <div className="keywords__list d-flex">
        {renderTags()}
        {renderButton()}
      </div>
    </div>
  );
};

export default Keywords;
